import React from "react";
import PropTypes from "prop-types";
import * as GBConst from "../../GB/GBConst";
import { getDelphiHexFromHexColor, toBase10, equal, notEqual } from "../../GB/GBUtil";
import * as Theme from "../../../app/Theme";
import {
    getIntervObj,
    getIntervAreaName,
    getIntervFirstYearScaleUp,
    getIntervFinalYearScaleUp,
} from "../NonVisual/HLUtil";
import * as HLConst from "../NonVisual/HLConst";
import GbStdTable from "../../common/GBStdTableAG/GbStdTable";
import TSwitch from "../../common/TSwitch";
import TLabel from "../../common/TLabel";

const rankedIntervTableC = {
    hiddenCol: 0,
    rankingCol: 1,
    percentCol: 2,
    intervCol: 3,
    summaryIntervGroupCol: 4,
    //specDisAreaCol             : 3,
    currCovCol: 5,
    targCovCol: 6,

    numHeaderRows: 1,

    hiddenColWidth: 0,
    rankingColWidth: 60,
    percentColWidth: 80,
    intervColWidth: 300,
    summaryIntervGroupColWidth: 200,
    //specDisAreaColWidth        : 200,
    currCovColWidth: 100,
    targCovColWidth: 100,
};

class HLResultForm extends React.Component {
    static propTypes = {
        intervAreaObjList: PropTypes.arrayOf(PropTypes.object),
        intervObjList: PropTypes.arrayOf(PropTypes.object),

        passData: PropTypes.func, // markRef

        rankedIntervMstID2DObjArray: PropTypes.arrayOf(PropTypes.number),

        resultWkbkFileURLString: PropTypes.string,

        showChildrenIntervBool: PropTypes.bool,
        onShowChildrenIntervChange: PropTypes.func,

        showMaternalIntervBool: PropTypes.bool,
        onShowMaternalIntervChange: PropTypes.func,
    };

    static defaultProps = {
        intervAreaObjList: [],

        intervObjList: [],

        passData: () => console.log("passData"),

        rankedIntervMstID2DObjArray: [],

        resultWkbkFileURLString: "",

        showChildrenIntervBool: true,
        onShowChildrenIntervChange: () => console.log("onShowChildrenIntervChange"),

        showMaternalIntervBool: true,
        onShowMaternalIntervChange: () => console.log("onShowMaternalIntervChange"),
    };

    // markRef
    state = {
        tableRef: React.createRef(),
    };

    // markRef
    componentDidMount() {
        this.props.passData({
            tableRef: this.state.tableRef,
        });
    }

    onDownloadBtnClick = () => {
        /* Props */
        const props = this.props;
        const resultWkbkFileURLString = props.resultWkbkFileURLString;

        if (resultWkbkFileURLString !== "") {
            console.log(window.API_URL_BASE + "/" + resultWkbkFileURLString);
            let a = document.createElement("a");
            a.href = window.API_URL_BASE + "/" + resultWkbkFileURLString;
            a.download = "Prioritized interventions.xlsx";
            document.body.appendChild(a);
            a.click();
            a.remove();
        }
        //this.state.tableRef.current.exportToExcel("RankedInterventions.xlsx");
    };

    onChildrenSwitchClick = (checked) => {
        this.props.onShowChildrenIntervChange(checked);
    };

    onMaternalSwitchClick = (checked) => {
        this.props.onShowMaternalIntervChange(checked);
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    renderRankedIntervTable = () => {
        let rankedIntervTable;

        const hlc = HLConst;

        /* Props */
        const props = this.props;
        const intervAreaObjList = props.intervAreaObjList;
        const intervObjList = props.intervObjList;
        const rankedIntervMstID2DObjArray = props.rankedIntervMstID2DObjArray;
        const showChildrenIntervBool = props.showChildrenIntervBool;
        const showMaternalIntervBool = props.showMaternalIntervBool;

        /* Const */
        const hAlign = GBConst.hAlign;
        // const english = GBConst.language.english;
        const intervObjC = HLConst.intervObj;
        const rankedIntervObjC = HLConst.rankedIntervObj;

        // const hiddenCol = rankedIntervTableC.hiddenCol;
        const intervCol = rankedIntervTableC.intervCol;
        const summaryIntervGroupCol = rankedIntervTableC.summaryIntervGroupCol;
        //const specDisAreaCol = rankedIntervTableC.specDisAreaCol;
        const currCovCol = rankedIntervTableC.currCovCol;
        const targCovCol = rankedIntervTableC.targCovCol;
        const rankingCol = rankedIntervTableC.rankingCol;
        const percentCol = rankedIntervTableC.percentCol;

        // const hiddenColWidth = rankedIntervTableC.hiddenColWidth;
        const intervColWidth = rankedIntervTableC.intervColWidth;
        const summaryIntervGroupColWidth = rankedIntervTableC.summaryIntervGroupColWidth;
        //const specDisAreaColWidth = rankedIntervTableC.specDisAreaColWidth;
        const currCovColWidth = rankedIntervTableC.currCovColWidth;
        const targCovColWidth = rankedIntervTableC.targCovColWidth;
        const rankingColWidth = rankedIntervTableC.rankingColWidth;
        const percentColWidth = rankedIntervTableC.percentColWidth;

        const numCols = targCovCol;

        let intervType = HLConst.noInterv;
        if (showChildrenIntervBool && showMaternalIntervBool) {
            intervType = HLConst.allIntervTypes;
        } else if (!showChildrenIntervBool && showMaternalIntervBool) {
            intervType = HLConst.maternalInterv;
        } else if (showChildrenIntervBool && !showMaternalIntervBool) {
            intervType = HLConst.childrenInterv;
        }

        const numHeaderRows = rankedIntervTableC.numHeaderRows;

        let numPossibleRows = numHeaderRows;
        let numIntervRows = 0;

        if (intervType !== HLConst.noInterv) {
            for (let i = 1; i <= rankedIntervMstID2DObjArray[intervType].length; i++) {
                const intervObj = getIntervObj(
                    rankedIntervMstID2DObjArray[intervType][i - 1][rankedIntervObjC.mstID],
                    intervObjList
                );

                if (
                    (intervObj[intervObjC.isChildren] && showChildrenIntervBool) ||
                    (intervObj[intervObjC.isMaternal] && showMaternalIntervBool)
                ) {
                    numIntervRows += 1;
                }
            }

            numPossibleRows += rankedIntervMstID2DObjArray[intervType].length;
        }

        const actualNumRows = numIntervRows + numHeaderRows;

        let WordWrappedCols = [];
        WordWrappedCols.length = numCols;
        WordWrappedCols.fill(true);
        let rowHeights1DIntArray = [];
        rowHeights1DIntArray.length = actualNumRows;
        rowHeights1DIntArray.fill(25);
        rowHeights1DIntArray[0] = 40;
        const colWidths1DIntArray = [
            rankingColWidth,
            percentColWidth,
            intervColWidth,
            summaryIntervGroupColWidth, //specDisAreaColWidth,
            currCovColWidth,
            targCovColWidth,
        ];
        let resultsTable2DArray = [];
        let lockedCells2DBoolArray = [];
        let max2DIntArray = [];
        let min2DIntArray = [];
        let hAlignments2DIntArray = [];
        let fontColors2DIntArray = [];
        let rDec2DIntArray = [];

        let intervIdx = 0;
        let row = 1;
        let rank = 0;
        let prevPercent = -1;
        for (let i = 1; i <= numPossibleRows; i++) {
            for (let c = 1; c <= numCols; c++) {
                /* Row header */
                if (row === 1) {
                    if (c === 1) {
                        resultsTable2DArray.push([]);
                        lockedCells2DBoolArray.push([]);
                        max2DIntArray.push([]);
                        min2DIntArray.push([]);
                        hAlignments2DIntArray.push([]);
                        fontColors2DIntArray.push([]);
                        rDec2DIntArray.push([]);
                    }

                    if (c === intervCol) {
                        resultsTable2DArray[row - 1].push("Intervention");
                    } else if (c === summaryIntervGroupCol) {
                        resultsTable2DArray[row - 1].push("Summary intervention group");
                    }
                    // else if (c === specDisAreaCol) {
                    //
                    //     resultsTable2DArray[r - 1].push("Specific disease area");
                    //
                    // }
                    else if (c === currCovCol) {
                        resultsTable2DArray[row - 1].push("Current coverage");
                    } else if (c === targCovCol) {
                        resultsTable2DArray[row - 1].push("Target coverage");
                    } else if (c === rankingCol) {
                        resultsTable2DArray[row - 1].push("Rank");
                    } else if (c === percentCol) {
                        resultsTable2DArray[row - 1].push("Percent impact");
                    } else {
                        resultsTable2DArray[row - 1].push("");
                    }

                    lockedCells2DBoolArray[row - 1].push(true);
                    hAlignments2DIntArray[row - 1].push(hAlign.center);
                    fontColors2DIntArray[row - 1].push(toBase10(getDelphiHexFromHexColor(Theme.blackColor)));
                    min2DIntArray[row - 1].push(0);
                    max2DIntArray[row - 1].push(0);
                    rDec2DIntArray[row - 1].push(0);

                    if (c === numCols) {
                        row += 1;
                    }
                } else {
                    /* Intervention rows */
                    const intervObj = getIntervObj(
                        rankedIntervMstID2DObjArray[intervType][intervIdx][rankedIntervObjC.mstID],
                        intervObjList
                    );

                    const intervMstID = intervObj[intervObjC.mstID];

                    if (
                        (intervObj[intervObjC.isChildren] && showChildrenIntervBool) ||
                        (intervObj[intervObjC.isMaternal] && showMaternalIntervBool)
                    ) {
                        if (c === 1) {
                            resultsTable2DArray.push([]);
                            lockedCells2DBoolArray.push([]);
                            max2DIntArray.push([]);
                            min2DIntArray.push([]);
                            hAlignments2DIntArray.push([]);
                            fontColors2DIntArray.push([]);
                            rDec2DIntArray.push([]);
                        }

                        if (c === intervCol) {
                            resultsTable2DArray[row - 1].push(
                                rankedIntervMstID2DObjArray[intervType][intervIdx][rankedIntervObjC.name]
                            );
                            //intervObj[intervObjC.name][english]);
                            hAlignments2DIntArray[row - 1].push(hAlign.left);
                            rDec2DIntArray[row - 1].push(0);
                        } else if (c === summaryIntervGroupCol) {
                            if (intervMstID !== hlc.microSuppIntervMstID) {
                                resultsTable2DArray[row - 1].push(
                                    getIntervAreaName(intervObj[intervObjC.intervAreaMstID], intervAreaObjList)
                                );
                            } else {
                                resultsTable2DArray[row - 1].push("*");
                            }

                            hAlignments2DIntArray[row - 1].push(hAlign.left);
                            rDec2DIntArray[row - 1].push(0);
                        }
                        // else if (c === specDisAreaCol) {
                        //
                        //     resultsTable2DArray[r - 1].push(
                        //         getDiseaseAreaName(
                        //             intervObj[intervObjC.intervAreaMstID],
                        //             intervObj[intervObjC.diseaseAreaMstID],
                        //             intervAreaObjList));
                        //     hAlignments2DIntArray[r - 1].push(hAlign.left);
                        //
                        // }
                        else if (c === currCovCol) {
                            if (intervMstID !== hlc.microSuppIntervMstID) {
                                resultsTable2DArray[row - 1].push(
                                    getIntervFirstYearScaleUp(
                                        intervObj[intervObjC.mstID],
                                        intervObjList,
                                        intervAreaObjList
                                    )
                                );
                            } else {
                                resultsTable2DArray[row - 1].push("*");
                            }

                            hAlignments2DIntArray[row - 1].push(hAlign.center);
                            rDec2DIntArray[row - 1].push(0);
                        } else if (c === targCovCol) {
                            if (intervMstID !== hlc.microSuppIntervMstID) {
                                resultsTable2DArray[row - 1].push(
                                    getIntervFinalYearScaleUp(
                                        intervObj[intervObjC.mstID],
                                        intervObjList,
                                        intervAreaObjList
                                    )
                                );
                            } else {
                                resultsTable2DArray[row - 1].push("*");
                            }
                            hAlignments2DIntArray[row - 1].push(hAlign.center);
                            rDec2DIntArray[row - 1].push(0);
                        } else if (c === rankingCol) {
                            let percent = rankedIntervMstID2DObjArray[intervType][intervIdx][rankedIntervObjC.percent];

                            if (notEqual(percent, prevPercent)) {
                                rank += 1;
                            }

                            prevPercent = percent;

                            resultsTable2DArray[row - 1].push(rank);
                            hAlignments2DIntArray[row - 1].push(hAlign.center);
                            rDec2DIntArray[row - 1].push(0);
                        } else if (c === percentCol) {
                            let percent = rankedIntervMstID2DObjArray[intervType][intervIdx][rankedIntervObjC.percent];

                            if (equal(percent, 0.0)) {
                                percent = "-";
                            }

                            resultsTable2DArray[row - 1].push(percent);
                            hAlignments2DIntArray[row - 1].push(hAlign.center);
                            rDec2DIntArray[row - 1].push(1);
                        } else {
                            resultsTable2DArray[row - 1].push();
                            hAlignments2DIntArray[row - 1].push(hAlign.center);
                            rDec2DIntArray[row - 1].push(0);
                        }

                        fontColors2DIntArray[row - 1].push(toBase10(getDelphiHexFromHexColor(Theme.blackColor)));
                        min2DIntArray[row - 1].push(0);
                        max2DIntArray[row - 1].push(0);
                        lockedCells2DBoolArray[row - 1].push(true);

                        if (c === numCols) {
                            row += 1;
                        }
                    }

                    if (c === numCols) {
                        intervIdx += 1;
                    }
                }
            }
        }

        const packTable = {
            Alignments: hAlignments2DIntArray,
            BandsOn: true,
            FontColors: fontColors2DIntArray,
            GBColCount: numCols,
            GBColWidths: colWidths1DIntArray,
            GBFixedCols: 0,
            GBFixedRows: 1,
            id: "rankedIntervPackTable",
            key: "rankedIntervPackTable",
            LockedCells: lockedCells2DBoolArray,
            MaxAllowedVal: max2DIntArray,
            MinAllowedVal: min2DIntArray,
            GBRowCount: actualNumRows,
            GBRowHeights: rowHeights1DIntArray,
            RDec: rDec2DIntArray,
            tableData: {
                value: resultsTable2DArray,
            },
            title: "Intervention rankings",
            WordWrappedCols: WordWrappedCols,
        };

        // markRef
        rankedIntervTable = (
            <GbStdTable
                font={"lato"}
                headerBackgroundColor={Theme.HL_PrimaryColor}
                key={"rankedIntervTable"}
                oddRowBackgroundColor={Theme.HL_BandColor}
                packTable={packTable}
                onPackTableChanged={() => {}}
                removedMenuNames={GBConst.menuItems.filter((s) => {
                    return s !== "Copy";
                })}
                style={{
                    fontFamily: Theme.fontFamily,
                    marginLeft: Theme.leftIndent,
                    //marginTop  : Theme.ctrlSpacing,
                    padding: 0,
                }}
                ref={this.state.tableRef}
            />
        );

        return (
            <div
                style={{
                    alignSelf: "flex-start",
                    display: "flex",
                    flexDirection: "column",
                    marginBottom: 20,
                    marginTop: 50,
                }}
            >
                {rankedIntervTable}
            </div>
        );
    };

    render() {
        const hlc = HLConst;

        const props = this.props;
        const showChildrenIntervBool = props.showChildrenIntervBool;
        const showMaternalIntervBool = props.showMaternalIntervBool;
        const intervAreaObjList = props.intervAreaObjList;
        const intervObjList = props.intervObjList;
        const rankedIntervMstID2DObjArray = props.rankedIntervMstID2DObjArray;

        const styles = {
            switchBoxStyle: {
                height: 20, // needed for circle to be centered because of TSwitch setup
            },
            switchLabelStyle: {
                fontSize: "14px",
                color: Theme.HL_SecondaryColor,
            },
            switchStyle: {
                alignSelf: "flex-start",
                color: "secondary",
                display: "flex",
            },
        };

        let intervAreasList = "";

        for (let i = 1; i <= intervAreaObjList.length; i++) {
            const intervAreaObj = intervAreaObjList[i - 1];
            const included = intervAreaObj.includeBool;

            if (included) {
                if (intervAreasList !== "") {
                    intervAreasList += ", ";
                }

                intervAreasList += intervAreaObj[HLConst.intervAreaObj.name][GBConst.language.english];
            }
        }

        const intervAreasLab = (
            <TLabel
                caption={"Showing prioritized interventions for the following intervention areas: " + intervAreasList}
                key={"intervAreasLab"}
                style={{
                    ...Theme.textFontStyle,
                    //color        : Theme.HL_SecondaryColor,
                    marginBottom: 20,
                    marginLeft: Theme.leftIndent,
                }}
            />
        );

        const resultsLab = (
            <TLabel
                caption={"Results"}
                key={"resultsLab"}
                style={{
                    ...Theme.labelFontStyle,
                    color: Theme.HL_SecondaryColor,
                    marginLeft: Theme.leftIndent,
                }}
            />
        );

        const maternalSwitchDiv = (
            <TSwitch
                boxStyle={styles.switchBoxStyle}
                style={styles.switchStyle}
                caption={"Maternal"}
                key={"maternalSwitch"}
                labelStyle={styles.switchLabelStyle}
                value={showMaternalIntervBool}
                onClick={this.onMaternalSwitchClick}
            />
        );

        const childrenSwitchDiv = (
            <TSwitch
                boxStyle={styles.switchBoxStyle}
                style={styles.switchStyle}
                caption={"Children"}
                key={"childrenSwitch"}
                labelStyle={styles.switchLabelStyle}
                value={showChildrenIntervBool}
                onClick={this.onChildrenSwitchClick}
            />
        );

        const switchDiv = (
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    marginLeft: Theme.leftIndent,
                }}
            >
                {maternalSwitchDiv}
                {childrenSwitchDiv}
            </div>
        );

        // const resultSwitchDiv =
        //     <div
        //         style = {{
        //             display : "inline-block",
        //             height  : 50,
        //             width   : 250,
        //         }}
        //     >
        //         {resultsLab}
        //         {switchDiv}
        //     </div>;

        // const downloadBtn = (
        //     <TButton
        //         caption={"Download tables"}
        //         captionStyles={{
        //             fontSize: 16,
        //             ...Theme.labelFontStyle,
        //             marginTop: 5,
        //             marginBottom: 5,
        //         }}
        //         containerStyle={{
        //             display: "inline-block",
        //             fontFamily: Theme.fontFamily,
        //             //marginBottom : 20,
        //             marginLeft: Theme.leftIndent,
        //             marginRight: 40,
        //             //marginTop    : Theme.topIndent,
        //         }}
        //         key={"downloadBtn"}
        //         style={{
        //             backgroundColor: Theme.HL_BtnBackgroundColor,
        //             fontFamily: Theme.fontFamily,
        //         }}
        //         onClick={this.onDownloadBtnClick}
        //     />
        // );

        /* Micronutrient supplementation (iron and multiple micronutrients) will not be in the intervObjList, only the
           ranked intervention area, so get the name from that. */

        // for (let i = 1; i <= rankedIntervMstID2DObjArray[HLConst.allIntervTypes].length; i++) {
        //
        //     const intervObj = getIntervObj(
        //         rankedIntervMstID2DObjArray[HLConst.allIntervTypes][i - 1][rankedIntervObjC.mstID], intervObjList);
        //
        //     if ((intervObj[intervObjC.isChildren] && showChildrenIntervBool) ||
        //         (intervObj[intervObjC.isMaternal] && showMaternalIntervBool)) {
        //
        //         numIntervRows += 1;
        //
        //     }
        //
        // }

        let showNote = false;

        let intervType = HLConst.noInterv;
        if (showChildrenIntervBool && showMaternalIntervBool) {
            intervType = HLConst.allIntervTypes;
        } else if (!showChildrenIntervBool && showMaternalIntervBool) {
            intervType = HLConst.maternalInterv;
        } else if (showChildrenIntervBool && !showMaternalIntervBool) {
            intervType = HLConst.childrenInterv;
        }

        if (intervType !== HLConst.noInterv) {
            let i = 1;
            while (i <= rankedIntervMstID2DObjArray[intervType].length && !showNote) {
                const intervObj = getIntervObj(
                    rankedIntervMstID2DObjArray[intervType][i - 1][HLConst.rankedIntervObj.mstID],
                    intervObjList
                );

                if (
                    intervObj[HLConst.intervObj.mstID] === HLConst.microSuppIntervMstID &&
                    ((intervObj[HLConst.intervObj.isChildren] && showChildrenIntervBool) ||
                        (intervObj[HLConst.intervObj.isMaternal] && showMaternalIntervBool))
                ) {
                    showNote = true;
                }

                i++;
            }
        }

        let microSuppIntervNote = null;

        if (showNote) {
            //const microSuppIntervObj = getIntervObj(hlc.microSuppIntervMstID, intervObjList);
            //const microSuppName = microSuppIntervObj[hlc.intervObj.name][GBConst.language.english];
            const nutritionGroupName = getIntervAreaName(hlc.nutritionAreaMstID, intervAreaObjList);
            const periconGroupName = getIntervAreaName(hlc.ANCAndDeliveryAreaMstID, intervAreaObjList);

            microSuppIntervNote = (
                <p
                    style={{
                        ...Theme.textFontStyle,
                        //color        : Theme.HL_SecondaryColor,
                        marginBottom: 20,
                        marginLeft: Theme.leftIndent,
                    }}
                >
                    * The ranking for "Micronutrient supplementation (iron and multiple micronutrients)" is dependent
                    upon interventions from the "{nutritionGroupName}" and "{periconGroupName}" intervention areas.
                    These areas may have different scale up-scenarios, so the intervention group, current coverage, and
                    target coverage are not reported.
                </p>
            );
        }

        // const box =
        //     <TBox
        //         alignContent   = {"center"}
        //         content        = {[resultSwitchDiv, downloadBtn]}
        //         justifyContent = {"space-between"}
        //         style          = {{
        //             margin  : 0,
        //             padding : 0,
        //         }}
        //     />;

        return (
            <div>
                {intervAreasLab}
                {resultsLab}
                {switchDiv}
                {this.renderRankedIntervTable()}
                {microSuppIntervNote}
            </div>
        );
    }
}

export default HLResultForm;
